// project-imports
import blogReducer from './blogReducer';
import categoriesReducer from './categoriesReducer';
import coursesReducer from './coursesReducer';
import domainReducer from './domainReducer';
import enquiryReducer from './enquiryReducer';
import filterReducer from './filterReducer';
import testimonialReducer from './testimonialReducer';
import youtubeReducer from './youtubeReducer';
import instructorReducer from './instructorReducer';
import userReducer from './userReducer';
import orderReducer from './orderReducer';
import productReducer from './productReducer';
import statsReducer from './statsReducer';
import galleryReducer from './galleryReducer';
import interviewReducer from './interviewReducer';
import quickInsightsReducer from './quickInsightsReducer';
import bugReducer from './bugReducer';

// third-party
import { combineReducers } from '@reduxjs/toolkit';

// combining the reducers
const rootReducers = combineReducers({
    blog: blogReducer,
    category: categoriesReducer,
    courses: coursesReducer,
    domain: domainReducer,
    enquiry: enquiryReducer,
    filter: filterReducer,
    testimonial: testimonialReducer,
    youtube: youtubeReducer,
    instructor: instructorReducer,
    user: userReducer,
    orders: orderReducer,
    products: productReducer,
    stats: statsReducer,
    gallery: galleryReducer,
    interview: interviewReducer,
    quickInsights: quickInsightsReducer,
    bug: bugReducer,
});
export default rootReducers;

